import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'safe_third_country'
const storeType = 'safeThirdCountries'

export const PESafeThirdCountriesCardActions = {
  initPeSafeThirdCountriesCard: ({ commit }, index) => {
    commit('setPeSafeThirdCountriesCardLock', { index, lock: true })
  },
  peFetchSafeThirdCountriesCards: async ({ commit, getters }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  peSafeThirdCountriesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            country_id: section.country_id,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeSafeThirdCountriesCardLock', { index: 'new', lock: true })
        commit('setPeSafeThirdCountriesCardLock', { index: data.id, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peSafeThirdCountriesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPeSafeThirdCountriesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  peSafeThirdCountriesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            country_id: section.country_id,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeSafeThirdCountriesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peSafeThirdCountriesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeSafeThirdCountriesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peSafeThirdCountriesCardAddSection: ({ commit }) => {
    commit('setPeSafeThirdCountriesCardLock', { index: 'new', lock: false })
    commit('addPeSafeThirdCountriesCardSection', {
      id: null,
      country_id: null,
      narrative: '',
    })
  },
  peSafeThirdCountriesCardDownloadPDF: async ({ getters }, { legalCaseId }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`, { asylum_assistant: { legal_case_id: legalCaseId } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PESafeThirdCountriesCardMutations = {
  setPeSafeThirdCountriesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.SafeThirdCountriesCard) {
      Vue.set(state.partyEdit.partySections, 'SafeThirdCountriesCard', {})
    }
    Vue.set(state.partyEdit.partySections.SafeThirdCountriesCard, index, lock)
  },
  addPeSafeThirdCountriesCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  peSafeThirdCountriesCardCreateUndo: state => {
    state.partyEdit.asylumAssystant[storeType].pop()
    Vue.set(state.partyEdit.partySections.SafeThirdCountriesCard, 'new', true)
  },
}

export const PESafeThirdCountriesCardGetters = {
  peSafeThirdCountriesCardLock: state => index => state.partyEdit.partySections.SafeThirdCountriesCard[index],
  peSafeThirdCountriesCardHasNewSection: state => !!state.
    partyEdit.
    asylumAssystant[storeType]?.
    find(safeThirdCountry => safeThirdCountry.id === null),
}
